import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { EMPLOYEE_MANAGEMENT_ROUTES } from './routes';
import { RestaurantStackParams } from './types';
import { SplitRestaurantEmployeesScreen } from '@/screens/restaurant/split-restaurant-employees-screen';
import { useDefaultAppTabScreenOptions } from '@/hooks/use-default-app-tab-screen-options';

const Stack = createStackNavigator<RestaurantStackParams>();

export const RestaurantStack: React.FC = () => {
  const screenOptions = useDefaultAppTabScreenOptions('screen');

  return (
    <Stack.Navigator
      initialRouteName={EMPLOYEE_MANAGEMENT_ROUTES.Employees}
      screenOptions={screenOptions}
    >
      <Stack.Screen
        component={SplitRestaurantEmployeesScreen}
        name={EMPLOYEE_MANAGEMENT_ROUTES.Employees}
      />
    </Stack.Navigator>
  );
};
